
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveals(root) {
    var els = (root || document).querySelectorAll('[data-reveal]:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function dropdowns() {
    document.querySelectorAll('[data-dropdown]').forEach(function (dd) {
      var btn = dd.querySelector('[data-dropdown-toggle]');
      var panel = dd.querySelector('[data-dropdown-panel]');
      if (!btn || !panel) return;
      var open = function (v) {
        dd.classList.toggle('open', v);
        btn.setAttribute('aria-expanded', v ? 'true' : 'false');
        panel.hidden = !v;
      };
      open(false);
      dd.addEventListener('mouseenter', function () { open(true); });
      dd.addEventListener('mouseleave', function () { open(false); });
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open(panel.hidden);
      });
      dd.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    });
  }

  function panels() {
    document.querySelectorAll('[data-panel-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var t = document.getElementById(btn.getAttribute('data-panel-open'));
        if (!t) return;
        t.classList.add('open');
        t.hidden = false;
        document.body.style.overflow = 'hidden';
        var f = t.querySelector('input,button,a');
        if (f) f.focus();
      });
    });
    document.querySelectorAll('[data-panel-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var t = btn.closest('[data-panel]');
        if (!t) return;
        t.classList.remove('open');
        t.hidden = true;
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-panel].open').forEach(function (t) {
        t.classList.remove('open');
        t.hidden = true;
        document.body.style.overflow = '';
      });
    });
  }

  function tabs() {
    document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
      wrap.addEventListener('click', function (e) {
        var b = e.target.closest('[data-tab-target]');
        if (!b) return;
        var root = wrap.closest('[data-tabs-root]') || document;
        wrap.querySelectorAll('[data-tab-target]').forEach(function (t) {
          var on = t === b;
          t.classList.toggle('active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = root.querySelector('#' + t.getAttribute('data-tab-target'));
          if (panel) panel.hidden = !on;
        });
      });
    });
  }

  function carousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (root) {
      var slides = root.querySelectorAll('[data-slide]');
      var dots = root.querySelectorAll('[data-dot]');
      if (slides.length < 2) return;
      var i = 0, timer = null;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
      }
      function start() { if (!reduce) timer = setInterval(function () { show(i + 1); }, 5000); }
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-dot'), 10));
          if (timer) { clearInterval(timer); start(); }
        });
      });
      show(0);
      start();
    });
  }

  function quickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var label = btn.textContent;
      btn.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { return rerenderDrawer(); })
        .then(function () {
          var drawer = document.getElementById('CartDrawer');
          if (drawer) { drawer.classList.add('open'); drawer.hidden = false; document.body.style.overflow = 'hidden'; }
        })
        .catch(function () {})
        .finally(function () { btn.disabled = false; btn.textContent = label; });
    });
  }

  function rerenderDrawer() {
    return fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#CartDrawer');
        var live = document.getElementById('CartDrawer');
        if (fresh && live) {
          live.replaceWith(fresh);
          cartDrawer();
          panels();
        }
      })
      .catch(function () {});
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
          n.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  function parallax() {
    var els = [].slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var wrap = el.parentElement;
        var rect = wrap.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.14;
        var progress = (vh - rect.top) / (vh + rect.height);
        var t = (progress - 0.5) * speed * rect.height;
        el.style.transform = 'translateY(' + t.toFixed(1) + 'px) scale(1.15)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { requestAnimationFrame(update); ticking = true; } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function whatsapp() {
    var w = document.querySelector('.lun-wa');
    if (!w) return;
    setTimeout(function () { w.classList.remove('opacity-0'); w.classList.add('opacity-100'); }, 1500);
    w.querySelectorAll('.lun-wa__btn').forEach(function (btn) {
      var tip = btn.parentElement.querySelector('.lun-wa__tip');
      if (!tip) return;
      function show(on) {
        tip.classList.toggle('opacity-0', !on);
        tip.classList.toggle('translate-x-4', !on);
        tip.classList.toggle('opacity-100', on);
        tip.classList.toggle('translate-x-0', on);
      }
      btn.addEventListener('mouseenter', function () { show(true); });
      btn.addEventListener('mouseleave', function () { show(false); });
      btn.addEventListener('focus', function () { show(true); });
      btn.addEventListener('blur', function () { show(false); });
    });
  }

  function cartDrawer() {
    document.querySelectorAll('.lun-ship-bar').forEach(function (el) {
      el.style.width = (parseFloat(el.getAttribute('data-pct')) || 0) + '%';
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      e.preventDefault();
      b.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: Number(b.getAttribute('data-value')) })
      }).then(function () { window.location.reload(); }).catch(function () { b.disabled = false; });
    });
  }

  function stickyAtc() {
    var bar = document.querySelector('.lun-atc-bar');
    var foot = document.querySelector('footer');
    if (!bar || !foot) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('lun-atc-bar--hidden', e.isIntersecting);
        document.body.classList.toggle('lun-atc-off', e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    io.observe(foot);
  }

  function init() {
    cartDrawer();
    whatsapp();
    stickyAtc();
    parallax();
    reveals(document);
    dropdowns();
    panels();
    tabs();
    carousels();
    quickAdd();
    refreshCart().catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    reveals(e.target);
    dropdowns();
    panels();
    tabs();
    carousels();
  });
})();
